import { convertToError } from './convertToError';

export default convertToError;
export { convertToError } from './convertToError';
